import { action } from 'easy-peasy';

import { IActionSetDashboardReport } from '../types';

const setDashboardReport: IActionSetDashboardReport = action((state, payload) => {
  state.dashboard = payload;
});

export default setDashboardReport;
